import { first } from 'lodash';
import i18next from 'i18next';

import sortActionsList from '@commons/utils/sortActionsList';

export const getRowActionsSettings = ({
  handleUpdateAssociateStoreCode,
  handleUpdateAssociatedStore,
  openGenericModal,
  shouldDisplayEdi,
  handleExport,
  supplier,
  getAssociatedStoreCodeParams,
  isAllowedToEdit,
  openEdiFlowsModal,
}) => {
  const rowActions = [
    {
      id: 'edit-client-code',
      actionLabel: () => i18next.t('ADMIN.SUPPLIERS.ASSOCIATED_STORES_MANAGE_CLIENT_CODE'),
      handleAction: (associatedStore) => {
        const params = getAssociatedStoreCodeParams(
          associatedStore,
          handleUpdateAssociateStoreCode,
          handleUpdateAssociatedStore,
          associatedStore.customerCode,
          'customerCode',
        );

        openGenericModal(params);
      },
      actionIcon: () => '/images/inpulse/gear-black-small.svg',
      isHidden: () => !isAllowedToEdit,
    },
    {
      id: 'edit-warehouse-code',
      actionLabel: () => i18next.t('ADMIN.SUPPLIERS.ASSOCIATED_STORES_MANAGE_WAREHOUSE_CODE'),
      handleAction: (associatedStore) => {
        const params = getAssociatedStoreCodeParams(
          associatedStore,
          handleUpdateAssociateStoreCode,
          handleUpdateAssociatedStore,
          associatedStore.warehouseCode,
          'warehouseCode',
        );

        openGenericModal(params);
      },
      actionIcon: () => '/images/inpulse/gear-black-small.svg',
      isHidden: () => !isAllowedToEdit,
    },
    {
      id: 'export-one',
      actionLabel: () => i18next.t('GENERAL.EXPORT_SELECTION'),
      handleAction: (item) => handleExport([item], supplier),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
    },

    ...(shouldDisplayEdi && isAllowedToEdit
      ? [
          {
            id: 'edit-edi-flows',
            actionLabel: () => i18next.t('ADMIN.SUPPLIERS.MANAGE_EDI_FLOWS'),
            handleAction: (item) => openEdiFlowsModal([item]),
            actionIcon: () => '/images/inpulse/gear-black-small.svg',
          },
        ]
      : []),
  ];

  return sortActionsList(rowActions);
};

export const getActionsSettings = ({
  selectedItems,
  handleUpdateAssociateStoreCode,
  handleUpdateAssociatedStore,
  openGenericModal,
  shouldDisplayEdi,
  handleExport,
  associatedStores,
  supplier,
  getAssociatedStoreCodeParams,
  isAllowedToEdit,
  openStoreSupplierProfileMappingImportModal,
  handleExportStoreSupplierProfileMappingTemplate,
  openEdiFlowsModal,
}) => {
  const hasSelectedItems = !!selectedItems.length;
  const oneObjectSelected = selectedItems.length === 1;
  const actions = [
    {
      id: 'edit-client-code',
      actionLabel: i18next.t('ADMIN.SUPPLIERS.ASSOCIATED_STORES_MANAGE_CLIENT_CODE'),
      handleAction: (items) => {
        // Action only available for one object selected
        const associatedStore = first(items);

        const params = getAssociatedStoreCodeParams(
          associatedStore,
          handleUpdateAssociateStoreCode,
          handleUpdateAssociatedStore,
          associatedStore.customerCode ? associatedStore.customerCode.trim() : '',
          'customerCode',
        );

        openGenericModal(params);
      },
      actionIcon: () => '/images/inpulse/gear-black-small.svg',
      isHidden: () => !oneObjectSelected || !isAllowedToEdit,
    },
    {
      id: 'edit-warehouse-code',
      actionLabel: i18next.t('ADMIN.SUPPLIERS.ASSOCIATED_STORES_MANAGE_WAREHOUSE_CODE'),
      handleAction: (items) => {
        // Action only available for one object selected
        const associatedStore = first(items);

        const params = getAssociatedStoreCodeParams(
          associatedStore,
          handleUpdateAssociateStoreCode,
          handleUpdateAssociatedStore,
          associatedStore.warehouseCode ? associatedStore.warehouseCode.trim() : '',
          'warehouseCode',
        );

        openGenericModal(params);
      },
      actionIcon: () => '/images/inpulse/gear-black-small.svg',
      isHidden: () => !oneObjectSelected || !isAllowedToEdit,
    },
    {
      id: 'download-batch-template-file',
      actionLabel: i18next.t('ADMIN.SUPPLIERS.ASSOCIATED_STORES_DOWNLOAD_BATCH_TEMPLATE_FILE'),
      handleAction: handleExportStoreSupplierProfileMappingTemplate,
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
    },
    {
      id: 'import-batch-file',
      actionLabel: i18next.t('ADMIN.SUPPLIERS.ASSOCIATED_STORES_IMPORT_BATCH_FILE'),
      handleAction: openStoreSupplierProfileMappingImportModal,
      actionIcon: () => '/images/inpulse/file-upload-black-small.svg',
    },
    {
      id: 'export',
      actionLabel: selectedItems.length
        ? i18next.t('GENERAL.EXPORT_SELECTION')
        : i18next.t('GENERAL.EXPORT_LIST_XLS'),
      handleAction: () =>
        selectedItems.length
          ? handleExport(selectedItems, supplier)
          : handleExport(associatedStores, supplier),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
    },
  ];

  const ediActions =
    shouldDisplayEdi && isAllowedToEdit && hasSelectedItems
      ? [
          {
            id: 'edit-edi-flows',
            actionLabel: i18next.t('ADMIN.SUPPLIERS.MANAGE_EDI_FLOWS'),
            handleAction: () => openEdiFlowsModal(selectedItems),
            actionIcon: () => '/images/inpulse/gear-black-small.svg',
          },
        ]
      : [];

  return sortActionsList([...actions, ...ediActions]);
};

export default {
  getActionsSettings,
  getRowActionsSettings,
};
